let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bL0cp")).then(() => parcelRequire('fXTZj'));